import { calcBiasedRandomNbr } from "../../../objects/CommonUse/randomBias";

export const determineInterestRates = (savingsType) => {
    let intRate = 0;
    switch(savingsType){
        case "regular":
            intRate = (calcBiasedRandomNbr (30, 40, 30, .75)/10000);
            break;
        case "CD":
            intRate = (calcBiasedRandomNbr (20, 55, 38, .75)/1000);
            break;
        case "highYield":
            intRate = (calcBiasedRandomNbr (30, 60, 45, .75)/1000);
            break;
        
        default:
            break;
    }    
   
    return intRate;
}
export default determineInterestRates;